<template>
  <div class="app-container">
    <el-tabs @tab-click="handleClick" v-model="activeName">
      <el-tab-pane
        :label="item.name"
        :name="item.id"
        v-for="(item, index) in qiyeList"
        :key="index + 'qiye'"
      ></el-tab-pane>
    </el-tabs>
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch">
      <el-form-item label="所属部门" prop="deptId">
        <el-select style="width: 100%" v-model="queryParams.deptId" placeholder="请选择所属部门" clearable filterable>
          <el-option
            v-for="item in deptList"
            :key="item.deptId + 'deptId'"
            :label="item.deptName"
            :value="item.deptId"
            v-show="item.parentId != 0 && item.parentId != 100"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入打卡人姓名"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>

      <el-form-item label="联系人电话" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入联系人电话"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="打卡方式" prop="unlockMode">
        <el-select v-model="queryParams.unlockMode" placeholder="请选择打卡方式" filterable clearable>
          <el-option
            v-for="(item, index) in unlockModeList"
            :key="index + 'unlockMode'"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="打卡时间">
        <el-date-picker
          v-model="dateRangeList"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
        <!-- <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button> -->
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8" hidden>
      <!-- <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['system:company:add']"
        >新增</el-button>
      </el-col> -->
      <el-col :span="1.5" v-if="dateRangeList != null">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="companyList" @selection-change="handleSelectionChange" height="500">
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <!-- <el-table-column label="id" align="center" prop="id" /> -->
      <el-table-column label="所属部门" align="center" prop="deptName" show-overflow-tooltip width="150" />
      <el-table-column label="姓名" align="center" prop="name" width="120" show-overflow-tooltip />
      <el-table-column label="电话" align="center" prop="phone" width="150" show-overflow-tooltip />
      <el-table-column label="打卡方式" align="center" prop="unlockMode" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.unlockMode == '人脸解锁'">刷脸设备</span>
          <span v-else>{{ scope.row.unlockMode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="打卡时间" align="center" prop="time" show-overflow-tooltip width="180" />
      <!-- <el-table-column label="外勤打卡图片" align="center" prop="reasonImg" /> -->

      <el-table-column label="外勤照片" align="center" width="150">
        <template slot-scope="scope">
          <image-preview :src="scope.row.reasonImg" :width="35" :height="35" />
        </template>
      </el-table-column>
      <el-table-column label="打卡状态" prop="status" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.status==0">正常</span>
          <span v-if="scope.row.status==1" style="color:#ff9000 ">补卡</span>
          <span v-if="scope.row.status==2"  style="color:#ff0000 ">迟到</span>
          <span v-if="scope.row.status==3"  style="color:#ff0000 ">早退</span>
          <span v-if="scope.row.status==4" style="color:#ff9000 ">未分配考勤组</span>
          <span v-if="scope.row.status==5">上班</span>
          <span v-if="scope.row.status==6">下班</span>
          <span v-if="scope.row.status==7" style="color:#8a8a8a ">已覆盖</span>
          <span v-if="scope.row.status==8" style="color:#048aff ">外勤打卡</span>
        </template>
      </el-table-column>
      <el-table-column label="外勤原因" prop="reason" show-overflow-tooltip width="200" />


      <el-table-column label="位置" prop="location" show-overflow-tooltip minwidth="150" />
      <!-- <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button icon="el-icon-search" circle size="mini" @click="handleEdits(scope.row)"></el-button>

          <el-button size="mini" type="danger" class="el-icon-delete" @click="handleDelete(scope.row)"></el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <pagination
      v-show="total > 0"
      :total="Number(total)"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!--新增编辑界面-->
    <!-- <el-drawer :title="title" :visible.sync="open" :before-close="handleClose" destroy-on-close
			class="headerts editdrawer" size="30%">
			<el-form ref="form" :model="form" :rules="rules" label-width="120px" style="padding-right: 30px"
				:disabled="title == '查看公司'">
				<el-col :span="24">
					<el-form-item label="公司名称" prop="name">
						<el-input v-model="form.name" placeholder="请输入公司名称" />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="联系人姓名" prop="contactName">
						<el-input v-model="form.contactName" placeholder="请输入联系人姓名" />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="联系人电话" prop="contactPhone">
						<el-input v-model="form.contactPhone" placeholder="请输入联系人电话" />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="公司地址" prop="address">
						<el-input v-model="form.address" placeholder="请输入公司地址" />
					</el-form-item>
				</el-col>
			</el-form>
			<div class="dialog-footer" v-if="title !== '查看公司'">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="cancel">取 消</el-button>
			</div>
		</el-drawer> -->
  </div>
</template>

<script>
import { unlockRecordPage } from '@/api/clockIn'
import axios from 'axios'
export default {
  name: 'Company',
  data() {
    return {
      reason: null,
      reasonImg: null,
      EId: this.$route.query.EId,
      url: this.$route.query.url,
      platformId: this.$route.query.platformId,
      activeName: '',
      deptList: [],
      qiyeList: [],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 公司表格数据
      companyList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        contactName: null,
        contactPhone: null,
        address: null,
        firstDay: undefined,
        lastDay: undefined,
        companyId: undefined,
        deptId: undefined,
        reason: null,
        reasonImg: null,
        unlockMode: undefined,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        name: [
          {
            required: true,
            message: '请选择输入正确公司名称',
            trigger: 'blur',
          },
        ],
        contactName: [
          {
            required: true,
            message: '请选择输入正确联系人姓名',
            trigger: 'blur',
          },
        ],
        contactPhone: [
          {
            required: true,
            message: '请选择输入正确联系人电话',
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请输入正确公司地址',
            trigger: 'blur',
          },
        ],
      },
      // 日期范围
      dateRangeList: '',
      statusList: [
        { id: 1, name: '补卡' },
        { id: 2, name: '迟到' },
        { id: 3, name: '早退' },
        { id: 4, name: '未分配考勤组' },
        { id: 5, name: '上班' },
        { id: 6, name: '下班' },
        { id: 7, name: '已覆盖' },
        { id: 8, name: '外勤' },
      ],
      unlockModeList: [
        { id: '地点打卡', name: '地点打卡' },
        { id: '人脸解锁', name: '刷脸设备' },
        { id: '外勤打卡', name: '外勤打卡' },
        { id: '补卡', name: '补卡' },
        { id: 'Wifi打卡', name: 'Wifi打卡' },
      ],
    }
  },
  created() {
    this.getQiyeList()
    // this.getDeptList()
    const currentDate = new Date()
    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
    const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
    this.dateRangeList = [startDate, endDate]
  },
  methods: {
    // 查看图片
    // previewImage(imageUrl) {
    // 	const img = new Image();
    // 	img.src = imageUrl;
    // 	const imgPreviewWindow = window.open('', '_blank', 'width=800,height=600');
    // 	imgPreviewWindow.document.write(`<img src="${imageUrl}" style="width: 100%; height: 100%;" />`);
    // },

    // 获取企业列表
    getQiyeList() {
      if (this.$route.query.EId == 'null') {
        var EId = null
      } else {
        var EId = this.$route.query.EId
      }
      axios({
        // url: this.url + "/OA/getUserList",
        url: this.url + '/system/company/listOut',
        method: 'get',
        params: {
          platformId: this.$route.query.platformId,
          id: EId,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.activeName = res.data.rows[0].id
          this.qiyeList = res.data.rows
          this.getDeptList(this.activeName)
          this.queryParams.companyId = this.activeName
          this.getList()
        }
      })
    },
    // 企业切换
    handleClick(e) {
      console.log(e)
      this.queryParams.deptId = null
      this.getDeptList(e.name)
      this.queryParams.companyId = e.name
      this.queryParams.unlockMode = undefined
      this.getList()
    },
    getDeptList(companyId) {
      console.log(companyId)
      axios({
        // url: this.url + "/OA/getUserList",
        url: this.url + '/system/dept/list',
        method: 'get',
        params: {
          platformId: this.$route.query.platformId,
          companyId: companyId,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.deptList = res.data.data
        }
      })
    },
    /** 查询打卡时间 */
    getList() {
      this.loading = true

      unlockRecordPage(this.queryParams).then((response) => {
        if (response.code == 200) {
          this.companyList = response.data.list
          this.total = response.data.total
          this.loading = false
        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        name: null,
        contactName: null,
        contactPhone: null,
        address: null,
        createTime: null,
      }
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      console.log(this.dateRangeList)
      if (this.dateRangeList != null) {
        if (this.dateRangeList.length != 0) {
          this.queryParams.firstDay = this.dateRangeList[0]
          this.queryParams.lastDay = this.dateRangeList[1]
        } else {
          this.queryParams.firstDay = undefined
          this.queryParams.lastDay = undefined
        }
      } else {
        this.queryParams.firstDay = undefined
        this.queryParams.lastDay = undefined
      }
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = '添加公司'
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      const id = row.id || this.ids
      getCompany(id).then((response) => {
        this.form = response.data
        this.open = true
        this.title = '修改公司'
      })
    },
    /** 查看按钮操作 */
    handleEdits(row) {
      this.reset()
      const id = row.id || this.ids
      getCompany(id).then((response) => {
        this.form = response.data
        this.open = true
        this.title = '查看公司'
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateCompany(this.form).then((response) => {
              this.$modal.msgSuccess('修改成功')
              this.open = false
              this.getList()
            })
          } else {
            addCompany(this.form).then((response) => {
              this.$modal.msgSuccess('新增成功')
              this.open = false
              this.getList()
            })
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids
      this.$modal
        .confirm('是否确认删除公司编号为"' + ids + '"的数据项？')
        .then(function() {
          return delCompany(ids)
        })
        .then(() => {
          this.getList()
          this.$modal.msgSuccess('删除成功')
        })
        .catch(() => {})
    },
    /** 导出按钮操作 */
    handleExport() {
      if (this.dateRangeList != null) {
        if (this.dateRangeList.length != 0) {
          this.queryParams.firstDay = this.dateRangeList[0]
          this.queryParams.lastDay = this.dateRangeList[1]
        } else {
          this.queryParams.firstDay = undefined
          this.queryParams.lastDay = undefined
        }
      } else {
        this.queryParams.firstDay = undefined
        this.queryParams.lastDay = undefined
      }

      this.download(
        'OA/unlockRecord/export',
        {
          ...this.queryParams,
        },
        `考勤记录_${new Date().getTime()}.xlsx`
      )
    },
    // 弹框退出事件
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style>
.dialog-footer {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
}
</style>
